const initialState = {
  sidebarShow: true,
  asideShow: false,
  theme: "default",
  sidebarUnfoldable: false,
};

export default function featureReducer(state = initialState, action) {
  switch (action.type) {
    case "SET_SIDERBAR_SHOW":
      return {
        ...state,
        sidebarShow: action.sidebarShow,
      };

    case "SET_THEME":
      return {
        ...state,
        theme: action.theme,
      };
    case "SET_ASIDESHOW":
      return {
        ...state,
        asideShow: action.asideShow,
      };
    case "SET_SIDEBAR_UNFOLDABLE":
      return {
        ...state,
        sidebarUnfoldable: action.sidebarUnfoldable,
      };
    default:
      return state;
  }
}
